import { useEffect } from "react";
import Lenis from "lenis";
import "@/App.css";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Ticker from "@/components/Ticker";
import Capabilities from "@/components/Capabilities";
import Contact from "@/components/Contact";

function App() {
  useEffect(() => {
    const text = "KB/XDU  ///  SPECIAL MISSION ELECTRONICS INTEGRATION  ///  ";
    let i = 0;
    const id = setInterval(() => {
      document.title = text.slice(i) + text.slice(0, i);
      i = (i + 1) % text.length;
    }, 220);
    return () => clearInterval(id);
  }, []);

  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true, anchors: true });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="min-h-screen bg-[#050505] font-body text-stone-100 antialiased">
      <div className="noise-overlay" aria-hidden="true" />
      <Navbar />
      <main>
        <Hero />
        <Ticker />
        <Capabilities />
        <Contact />
      </main>
    </div>
  );
}

export default App;
